  <div class="center">
    <h3 mat-dialog-title>Edición finalizada</h3>
    <br />
    <div mat-dialog-content>
      El registro se validó y se envió correctamente.
    </div>
    <br />

      <button
        class="centrado"
        type="button"
        (click)="close()"
        class="text-center u-btn button-100 u-btn--line"
      >
        Volver
      </button>
  </div>
